import React, { useContext } from "react";
import { Wealth } from "../../Networking/Interface/Account/AccountInterface";
import styles from "./WealthView.module.css";
import SetCashButton from "../../Staff/Actions/SetCash";
import { UserContext } from "../../User/UserContext";
import { MdAccountBalanceWallet, MdAccountBalance } from "react-icons/md";

type WealthViewProps = {
  characterName: string;
  userId: number;
  wealth: Wealth;
  setWealth: (wealth: Wealth) => void;
};

const WealthView: React.FC<WealthViewProps> = ({
  wealth,
  characterName,
  userId,
  setWealth,
}) => {
  const { user } = useContext(UserContext);
  const hasRole = (minLevel: number) => user && user.role >= minLevel;

  const totalWealth =
    wealth.onHandWealth +
    wealth.bankAccountWealth.reduce((sum, v) => sum + v, 0);

  return (
    <div className={styles.container}>
      {/* Total */}
      <div className={styles.totalRow}>
        <span className={styles.totalLabel}>Total Wealth</span>
        <span className={styles.totalAmount}>${totalWealth.toLocaleString()}</span>
        {hasRole(6) && (
          <div className={styles.setCashInline}>
            <SetCashButton
              userId={userId}
              characterName={characterName}
              setWealth={setWealth}
            />
          </div>
        )}
      </div>

      {/* Pill row */}
      <div className={styles.pillRow}>
        <div className={styles.pill}>
          <MdAccountBalanceWallet className={styles.pillIcon} />
          <div className={styles.pillContent}>
            <span className={styles.pillLabel}>On Hand</span>
            <span className={styles.pillValue}>${wealth.onHandWealth.toLocaleString()}</span>
          </div>
        </div>
        {wealth.bankAccountWealth.map((amount, index) => (
          <div key={index} className={styles.pill}>
            <MdAccountBalance className={styles.pillIcon} />
            <div className={styles.pillContent}>
              <span className={styles.pillLabel}>Bank {index + 1}</span>
              <span className={styles.pillValue}>${amount.toLocaleString()}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WealthView;
